import React from 'react';
import { Euro } from 'lucide-react';
import { cn } from '../../lib/utils';

interface SalaryBadgeProps {
  salary: string;
  className?: string;
  iconSize?: number;
  highlighted?: boolean;
}

export function SalaryBadge({ 
  salary, 
  className, 
  iconSize = 4,
  highlighted = false 
}: SalaryBadgeProps) {
  if (!salary) return null;
  
  return (
    <div 
      className={cn(
        "flex items-center gap-1.5",
        highlighted 
          ? "text-teal-700 bg-teal-50 px-2 py-1 rounded-full font-medium" 
          : "text-gray-600",
        className
      )}
    >
      <Euro className={`h-${iconSize} w-${iconSize} ${highlighted ? 'text-teal-600' : 'text-gray-400'}`} />
      <span className="text-sm">{salary}</span>
    </div>
  );
}